const Shift = () =>
  import(
    /* webpackChunkName: "courier-shift" */ '@/pages/courier/shift/index.vue'
  )

const CreateShift = () =>
  import(
    /* webpackChunkName: "courier-shift" */ '@/pages/courier/shift/create.vue'
  )

const EditShift = () =>
  import(
    /* webpackChunkName: "courier-shift" */ '@/pages/courier/shift/edit.vue'
  )

export default {
  path: 'shift',
  meta: {
    label: 'shift',
    auth: 'shift'
  },
  component: {
    name: 'Shift',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'ShiftReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Shift
    },
    {
      name: 'CreateShift',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateShift
    },
    {
      name: 'EditShift',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditShift,
      props: true
    }
  ]
}